import { useEffect, useState } from "react";
import { api, type Asesor } from "@/lib/api";

/**
 * Carga el catálogo de asesores comerciales **activos** una sola vez.
 *
 * La lista es corta (decenas), por eso se trae completa y se filtra en el
 * navegador: no hay endpoint de búsqueda de asesores ni hace falta.
 */
export function useAsesores() {
  const [asesores, setAsesores] = useState<Asesor[]>([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let vivo = true;
    void (async () => {
      try {
        const list = await api.get<Asesor[]>("/api/asesores");
        if (vivo) setAsesores(list.filter((a) => a.activo));
      } catch {
        // error de red — dejar la lista vacía; la UI lo dice
      } finally {
        if (vivo) setCargando(false);
      }
    })();
    return () => {
      vivo = false;
    };
  }, []);

  return { asesores, cargando };
}
